import PropTypes from 'prop-types';
import React from 'react';
import { Box, ResponsiveContext } from 'grommet';
import { Link } from 'gatsby';
import lukashorakLogo from '../images/logo_large.svg';
import { equals } from 'ramda';
import { getThemeColor } from '../theme';
import WebNavigation from './WebNavigation';
import SocialIconContacts from './SocialIconContacts';
import Headroom from 'react-headroom';

const renderLogo = screenSize => (
  // <Logo
  //   size={equals(screenSize, 'small') ? 35 : 40}
  //   color={getThemeColor('brand')}
  // />
  <Link
    to="/"
    css={`
      display: flex;
    `}
    alt="Lukas Horak Homepage"
  >
    <img
      src={lukashorakLogo}
      height={screenSize === 'small' ? '32px' : '35px'}
      alt="Lukas Horak Logo"
    />
  </Link>
);

const Header = () => {
  const screenSize = React.useContext(ResponsiveContext);
  return (
    <Headroom>
      <Box
        width="full"
        css={`
          background-color: ${getThemeColor('brand-dark-blue')};
          color: ${getThemeColor('brand-light-gray')};
        `}
      >
        <Box
          direction={'row'}
          alignContent={'center'}
          align={'center'}
          alignSelf={'center'}
          pad={'small'}
          justify={'between'}
          width="xxlarge"
        >
          <Box
            pad={{ vertical: 'xxsmall', horizontal: '10px' }}
            width="25%"
            align="start"
          >
            {renderLogo(screenSize)}
          </Box>

          {!equals(screenSize, 'small') && (
            <Box
              pad={{ vertical: 'xxsmall', horizontal: '0px' }}
              direction={'row'}
              justify={'center'}
              width={'50%'}
            >
              <WebNavigation />
            </Box>
          )}

          <Box
            pad={{ vertical: 'xsmall', horizontal: '10px' }}
            width={equals(screenSize, 'small') ? '75%' : '25%'}
            align="end"
          >
            {
              <SocialIconContacts
                size={equals(screenSize, 'small') ? '23px' : '1.5rem'}
              />
            }
          </Box>
        </Box>
        {equals(screenSize, 'small') && (
          <Box>
            <WebNavigation />
          </Box>
        )}
      </Box>
    </Headroom>
  );
};

Header.propTypes = {
  siteTitle: PropTypes.string,
};

Header.defaultProps = {
  siteTitle: ``,
};

export default Header;
